import { render, staticRenderFns } from "./OrderComments.vue?vue&type=template&id=bd0bfaf8&scoped=true"
import script from "./OrderComments.vue?vue&type=script&lang=js"
export * from "./OrderComments.vue?vue&type=script&lang=js"
import style0 from "./OrderComments.vue?vue&type=style&index=0&id=bd0bfaf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd0bfaf8",
  null
  
)

export default component.exports